const IS_PRODUCTION = window.location.href.includes("securesafe.futuremoney.co");

const production = {
  env: "production",
  api: {
    url: "https://api.futuremoney.co",
  }
};

const development = {
  env: "development",
  api: {
    url: "https://api.dev.futuremoney.co",
  }
};

export const environment = IS_PRODUCTION ? production : development;
